export const generalErrorMessage =
'We are sorry but an error has occurred and has been logged.' +
' If you continue to see this message or need further assistance please contact us at ' +
'policies@kindertons.co.uk or alternatively call us on +44 343 506 4316.';
